export class LotBulkDeleteViewModel {
    public readonly lotIds: number[]

    constructor(lotIds:number[]) {
        this.lotIds = lotIds;
    }
}